<div *ngIf="enableLayoutMenu">
  <app-shared-layout role="presentation"> </app-shared-layout>
</div>
<section>
  <div class="login_wraper" role="form" aria-labelledby="changePasswordHeading">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="login_section">
          <h1 class="right_header" tabindex="0">Change Password</h1>
          <form
          class="form-horizontal"
          #courseForm="ngForm"
          (ngSubmit)="updatePasssword($event)"
          role="form"
          aria-labelledby="changePasswordHeading"
          >
            <div class="form-group">
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    id="name"
                    placeholder="Current Password"
                    [(ngModel)]="oldpassword"
                    name="name"
                    id="oldpassword"
                  />
                  <img
                    class="eye_img"
                    src="assets/images/eye_img.png"
                    id="oldpassword_img"
                    alt="Show current password"
                    (click)="revealPassword('oldpassword', 'oldpassword_img')"
                    tabindex="0"
                    aria-label="Show current password"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    id="name"
                    placeholder="New Password"
                    [(ngModel)]="newpassword"
                    name="name"
                    id="newpassword"
                  />
                  <img
                    class="eye_img"
                    src="assets/images/eye_img.png"
                    id="newpassword_img"
                    alt="Show New password"
                    (click)="revealPassword('newpassword', 'newpassword_img')"
                    tabindex="0"
                    aria-label="Show new password"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    id="email"
                    placeholder="Confirm New Password"
                    [(ngModel)]="newpasswordconfirm"
                    name="email"
                    id="newpasswordconfirm"
                  />
                  <img
                    class="eye_img"
                    src="assets/images/eye_img.png"
                    id="confirmpassword_img"
                    alt="Show confirm password"
                    (click)="
                      revealPassword(
                        'newpasswordconfirm',
                        'confirmpassword_img'
                      )
                    "
                    tabindex="0"
                    aria-label="Show comfirm password"
                  />
                </div>
              </div>
            </div>
            <p class="pwd_hint">
              Your password cannot contain your email address, first name, or
              last name. It must be minimum of 8 characters in length,
              containing at least one upper case letter, one lower case letter,
              one number, and one special character.
            </p>

            <div class="col-lg-6 col-sm-6 col-md-6 col-xs-6">
              <div class="form-group">
                <button
                  class="btn btn-primary btn-lg btn-block login-button check_valid"
                  type="submit"
                >
                  Change Password
                </button>
              </div>
            </div>

            <div
              *ngIf="!enableCancel"
              class="col-lg-6 col-sm-6 col-md-6 col-xs-6"
            >
              <div class="form-group">
                <a
                  href="javascript:void(0)"
                  (click)="logout($event)"
                  class="btn btn-primary btn-lg btn-block login-button"
                  >Cancel</a
                >
              </div>
            </div>
            <div
              *ngIf="enableCancel"
              class="col-lg-6 col-sm-6 col-md-6 col-xs-6"
            >
              <div class="form-group">
                <a
                  href="javascript:void(0)"
                  (click)="HomePage()"
                  class="btn btn-primary btn-lg btn-block login-button"
                  >Cancel</a
                >
              </div>
            </div>
            <div *ngIf="errorMsg" class="errormsg">
              {{ errorMsg }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
